<ng-container *transloco="let t">
  <div class="label-wrapper">
    <label [for]="formControlName"
      >{{ label }}<ng-container *ngIf="required"><span [class.required-color]="requiredColor"> *</span></ng-container
      ><ng-container *ngIf="parentVisible"
        >&nbsp;<i [class]="iconService.eye" placement="top" [ngbTooltip]="t('child/parentInfo')"></i
      ></ng-container>

      <ng-container *ngIf="tooltipVisible"
        >&nbsp;<i [class]="iconService.infoCircle + ' tooltip-icon'" placement="top" [ngbTooltip]="tooltipText"></i
      ></ng-container>
      <ng-container *ngIf="showLoading$ | async"
        >&nbsp;
        <div class="spinner-border spinner-border-sm" role="status"></div
      ></ng-container>
    </label>
    <span *ngIf="maxInputLength$ | async" class="counter">{{ remainingChars$ | async }}</span>
  </div>
  <div class="input-wrapper">
    <input
      [id]="formControlName"
      [formControl]="getFormControl()"
      class="form-control form-control-lg"
      [placeholder]="placeholder && placeholder"
      [ngClass]="{
        'is-invalid':
          (required || customValidation) &&
          childForm.get(formControlName).invalid &&
          (childForm.get(formControlName).dirty || childForm.get(formControlName).touched)
      }"
      [type]="asPassword ? ((visible$ | async) ? type : 'password') : type"
      [autocomplete]="asPassword ? 'new-password' : ''"
      (input)="onInputChange($event)"
      [maxlength]="maxInputLength$ | async"
      [readonly]="readonly"
    />
    <i *ngIf="asPassword" (click)="visible$.next(!visible$.value)" class="material-symbols-rounded">
      <ng-container *ngIf="visible$ | async">visibility</ng-container>
      <ng-container *ngIf="(visible$ | async) === false">visibility_off</ng-container>
    </i>
  </div>
  <ng-container *ngIf="required || customValidation">
    <div
      *ngIf="childForm.get(formControlName).invalid && (childForm.get(formControlName).dirty || childForm.get(formControlName).touched)"
      class="invalid-feedback"
    >
      <div *ngIf="required && childForm.get(formControlName).hasError('required')">{{ formControlError }}</div>
      <div *ngIf="customValidation && childForm.get(formControlName).hasError(customErrorName)">
        {{ formControlCustomError }}
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="helpText">
    <div class="form-text">{{ helpText }}</div>
  </ng-container>
</ng-container>
